import { TElement, TText } from 'platejs';

import { formatNode } from 'features/Editor';

export const formatBlock = (block: TElement, isLastBlock?: boolean) => {
	let string = ``;

	if (block.type === 'blockquote') {
		string += `<blockquote>`;
	}

	if (block.type === 'code_block') {
		string += `<pre>`;
		if (block.lang) {
			string += `<code class="language-${block.lang}">`;
		}
	}

	if (block.type === 'a') {
		string += `<a href="${block.url}">`;
	}

	block.children.forEach((child, index) => {
		if ('type' in child && child.type && child.children) {
			string += formatBlock(child as TElement, index === block.children.length - 1);
		} else {
			string += formatNode(child as TText);
		}
	});

	if (block.type === 'a') {
		string += `</a>`;
	}

	if (block.type === 'code_block') {
		if (block.lang) {
			string += `</code>`;
		}
		string += `</pre>`;
	}

	if (block.type === 'blockquote') {
		string += `</blockquote>`;
	}

	if (!isLastBlock && block.type !== 'a') {
		string += `\n`;
	}

	return string;
};
